/**
 * Compteur unique pour la pastille d'icône OS :
 * notifs in-app non lues + messages Conversations non lus.
 */

export type AppBadgeConversationLike = {
  unreadMessagesCount?: number | null;
  hasUnreadMessages?: boolean;
};

export function computeAppBadgeCount(
  notificationUnread: number,
  conversations: AppBadgeConversationLike[] | null | undefined,
  options?: { includeChat?: boolean },
): number {
  const notif = Number.isFinite(notificationUnread)
    ? Math.max(0, Math.floor(notificationUnread))
    : 0;

  if (options?.includeChat === false) {
    return notif;
  }

  const list = Array.isArray(conversations) ? conversations : [];
  let chat = 0;
  for (const conv of list) {
    const n = conv?.unreadMessagesCount;
    if (typeof n === 'number' && Number.isFinite(n) && n > 0) {
      chat += Math.floor(n);
    } else if (conv?.hasUnreadMessages) {
      chat += 1;
    }
  }

  return notif + chat;
}
